import React from 'react';

import { PriceGroup } from '@ocx-app/modules/stores/types';

import { PricesGrid, PricesGridProps } from './prices-grid.component';

type PricesGridControllerProps = Omit<
  PricesGridProps,
  'prices' | 'isExpanded' | 'shouldLimitRenderItems' | 'onRevealRestPricesClick'
> & {
  priceGroups: PriceGroup[];
  pricesGridDefaultTitle?: string;
  isExpandedByDefault?: boolean;
};

export const PricesGridController: React.FC<PricesGridControllerProps> = ({
  priceGroups,
  pricesGridDefaultTitle,
  isExpandedByDefault,
}) => {
  return (
    <>
      {priceGroups.map((group, index) => {
        return (
          <PricesGrid
            key={group.title}
            title={priceGroups.length > 1 ? group.title : pricesGridDefaultTitle}
            prices={group.prices}
            isExpanded={isExpandedByDefault}
            marginTop={index > 0}
          />
        );
      })}
    </>
  );
};
